(function($) {
	$(() => {
		function scrollToDataTop() {
			$('html, body').animate({
				scrollTop: $('.previous-matches').offset().top
			});
		}

		const $showMoreButton = $('.previous-matches .show-more');
		const $loadingOverlay = $('.match-box-wrapper + .loading-overlay');
		const $matchBoxWrapper = $('.match-box-wrapper');

		function showSpinner() {
			$loadingOverlay.show();
			$matchBoxWrapper.hide();
			$showMoreButton.hide();
			scrollToDataTop();
		}

		function hideSpinner() {
			$matchBoxWrapper.show();
			$showMoreButton.show();
			$loadingOverlay.hide();
		}

		$('.form-control--date')
			.datepicker({
				format: 'yyyy.mm.dd.',
				language: 'hu',
				orientation: 'bottom',
				autoclose: true
			})
			.on('change', function() {
				$(this).trigger('propertychange');
			});

		if ($('.previous-matches').length) {
			// TODO filter matches <- NOW demonstrate loading overlay in work
			$('input').on('input propertychange', () => {
				showSpinner();

				setTimeout(() => {
					hideSpinner();
				}, 300);
			});

			// TODO get current selected match datas from database to show details on right side
			$(document).on('click', '.previous-matches .match-box:not(.active)', function () {
				const $this = $(this);

				// TODO get club images from database
				let logoHome = '';
				let logoAway = '';
				if ($this.find('.home_club')[0].innerHTML === 'FC Dataschema') {
					logoHome = 'assets/img/svg/dataschema_logo.svg';
					logoAway = 'assets/img/teams/logo-team-2.png';
				} else {
					logoHome = 'assets/img/teams/logo-team-2.png';
					logoAway = 'assets/img/svg/dataschema_logo.svg';
				}

				$('.match-box--detailed').find('.home_club').eq(0).text($this.find('.home_club')[0].innerHTML);
				$('.match-box--detailed').find('.away_club').eq(0).text($this.find('.away_club')[0].innerHTML);
				$('.match-box--detailed').find('.score').eq(0).text($this.find('.score.home')[0].innerHTML);
				$('.match-box--detailed').find('.score').eq(1).text($this.find('.score.away')[0].innerHTML);
				$('.match-box--detailed').find('.score_ht_home').eq(0).text($this.find('.score_ht_home')[0].innerHTML);
				$('.match-box--detailed').find('.score_ht_away').eq(0).text($this.find('.score_ht_away')[0].innerHTML);
				$('.match-box--detailed').find('.date').eq(0).text($this.find('.date')[0].innerHTML);
				$('.match-box--detailed').find('.location').eq(0).text($this.find('.location')[0].innerHTML);
				$('.match-box--detailed').find('img.home_club').eq(0).attr('src', logoHome);
				$('.match-box--detailed').find('img.away_club').eq(0).attr('src', logoAway);

				const prevImg = $('.heatmap-img').eq(0);
				prevImg.addClass('hide');
				// TODO swap heatmap or passes image
				setTimeout(() => {
					prevImg.removeClass('hide');
				}, 300);

				// TODO upgrade players list when matchbox clicked within previous matches block
			});
		}
	});
})(jQuery);
